import { render } from "./OutletView.vue?vue&type=template&id=cc3bb464"
import script from "./OutletView.vue?vue&type=script&lang=js"
export * from "./OutletView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__